import {fsa, fsaError, fsaPayload, fsaPayloadByKeys} from '../helpers'

export const START_LOOKBUILDING = 'lookbuilder/start look building flow'
export const startLookbuilding = fsa(START_LOOKBUILDING)

// View actions

export const OPEN_LOOKBUILDER_DETAIL_VIEW = 'lookbuilder/open lookbuilder detail view'
export const openLookbuilderDetailView = fsaPayloadByKeys(OPEN_LOOKBUILDER_DETAIL_VIEW, [
  'productSlug',
])

export const OPEN_LOOKBUILDER_CATEGORY_VIEW = 'lookbuilder/open lookbuilder category view'
export const openLookbuilderCategoryView = fsaPayloadByKeys(OPEN_LOOKBUILDER_CATEGORY_VIEW, [
  'category',
])

export const OPEN_LOOKBUILDER_PLANNER_VIEW = 'lookbuilder/open lookbuilder planner view'
export const openLookbuilderPlannerView = fsa(OPEN_LOOKBUILDER_PLANNER_VIEW)

// Look actions

export const ADD_TO_LOOKBUILDER_LOOK = 'lookbuilder/add product to the current lookbuilder look'
export const addToLookbuilderLook = fsa(ADD_TO_LOOKBUILDER_LOOK)

export const REMOVE_FROM_LOOKBUILDER_LOOK =
  'lookbuilder/remove product from the current lookbuilder look'
/**
 * @param {Object} payload
 * @param {String} payload.category The lookbuilder category slug
 * @param {String} payload.origin The location within lookbuilder
 */
export const removeFromLookbuilderLook = fsaPayloadByKeys(REMOVE_FROM_LOOKBUILDER_LOOK, [
  'category',
  'origin',
])

export const QUEUE_LOOKBUILDER_PRODUCTS =
  'lookbuilder/queues list of products to fetch for lookbuilder'
export const queueLookbuilderProducts = fsaPayloadByKeys(QUEUE_LOOKBUILDER_PRODUCTS, ['products'])

export const SAVE_LOOKBUILDER_LOOK = 'lookbuilder/save current lookbuilder look'
export const saveLookbuilderLook = fsa(SAVE_LOOKBUILDER_LOOK)

export const COPY_LOOKBUILDER_LOOK = 'lookbuilder/copy lookbuilder look'
export const copyLookbuilderLook = fsa(COPY_LOOKBUILDER_LOOK)

export const REMOVE_INCOMPATIBLE_PRODUCTS =
  'lookbuilder/remove incompatible products from lookbuilder look'
export const removeIncompatibleProducts = fsa(REMOVE_INCOMPATIBLE_PRODUCTS)

export const RESET_LOOKBUILDER_LOOK = 'lookbuilder/reset lookbuilder look'
export const resetLookbuilderLook = fsa(RESET_LOOKBUILDER_LOOK)

export const CONFIRM_REMOVE_FROM_LOOKBUILDER_LOOK = 'lookbuilder/confirm removing an item'
export const confirmRemoveFromLookbuilderLook = fsa(CONFIRM_REMOVE_FROM_LOOKBUILDER_LOOK)

// Internal actions - saga use only

export const NAVIGATE_TO_VIEW = 'lookbuilder/navigate to a lookbuilder view'
export const navigateToView = fsaPayloadByKeys(NAVIGATE_TO_VIEW, ['view'])

export const UPDATE_PLANNER_CATEGORY = 'lookbuilder/update entry for a category in the planner view'
export const updatePlannerCategory = fsaPayloadByKeys(UPDATE_PLANNER_CATEGORY, [
  'category',
  'product',
])

export const SELECT_TRANSACTION_TYPE = 'lookbuilder/select lookbuilder transaction type'
export const selectTransactionType = fsaPayloadByKeys(SELECT_TRANSACTION_TYPE, [
  'category',
  'transactionType',
])

// API fetching actions

export const GET_PRODUCT_SETS_PENDING = 'lookbuilder/get product sets for planner view pending'
export const getProductSetsPending = fsa(GET_PRODUCT_SETS_PENDING)

export const GET_PRODUCT_SETS_SUCCESS = 'lookbuilder/get product sets for planner view successful'
export const getProductSetsSuccess = fsaPayloadByKeys(GET_PRODUCT_SETS_SUCCESS, [
  'productsByCategory',
])

export const GET_PRODUCT_SETS_FAILURE = 'lookbuilder/get product sets for planner view failed'
export const getProductSetsFailure = fsaError(GET_PRODUCT_SETS_FAILURE)

export const GET_PRODUCTS_BY_CATEGORY_PENDING = 'lookbuilder/get products by category pending'
export const getProductsByCategoryPending = fsa(GET_PRODUCTS_BY_CATEGORY_PENDING)

export const GET_PRODUCTS_BY_CATEGORY_SUCCESS = 'lookbuilder/get products by category successful'
export const getProductsByCategorySuccess = fsaPayload(GET_PRODUCTS_BY_CATEGORY_SUCCESS)

export const GET_PRODUCTS_BY_CATEGORY_FAILURE = 'lookbuilder/get products by category failed'
export const getProductsByCategoryFailure = fsaError(GET_PRODUCTS_BY_CATEGORY_FAILURE)
